/**
 * Opening the planner straight into the AI Planner: the hike page's AI Planner
 * section (hikes/_ai_planner_section) links to the planner with ?ai_planner=1.
 * Pure.
 */

export const AI_PLANNER_PARAM = 'ai_planner';

/** Whether the planner was opened to start the AI Planner. */
export function aiPlannerRequested(search: string): boolean {
  return new URLSearchParams(search).get(AI_PLANNER_PARAM) === '1';
}

/** The same address without the request, so a reload doesn't start it again. */
export function withoutAiPlannerRequest(href: string): string {
  const url = new URL(href);
  url.searchParams.delete(AI_PLANNER_PARAM);
  return url.toString();
}
